import type { BeginnerTermId } from './beginnerTerms';

export type LearnCategory = {
  id: string;
  title: string;
  intro: string;
  termIds: BeginnerTermId[];
};

/** Categories reuse the existing glossary. Intros restate product disclaimers already shown in the app. */
export const LEARN_CATEGORIES: LearnCategory[] = [
  {
    id: 'numbers',
    title: 'Understanding the numbers',
    intro:
      'Profit, cash required, and return figures are calculated from the assumptions you enter. Cash-on-cash return in DealSkout is a project return, not an annualized rate. None of these figures is a recommendation to purchase.',
    termIds: [
      'arv',
      'cashOnCashReturn',
      'returnOnCost',
      'breakEvenSalePrice',
      'mao',
      'targetCashOnCash',
      'holdingPeriod',
    ],
  },
  {
    id: 'comps',
    title: 'Comparable sales',
    intro:
      'Comps are sold properties you enter, import, or retrieve with an automatic search. A comp-based indication uses included sales and is not an appraisal.',
    termIds: ['compBasedIndication', 'pricePerSqft'],
  },
  {
    id: 'rehab',
    title: 'Rehab & financing',
    intro:
      'Rehab can be a single estimate or line items plus contingency. Financing costs follow the loan assumptions you confirm. Condition does not set a dollar budget by itself.',
    termIds: [
      'rehabContingency',
      'rehabCondition',
      'loanPoints',
      'purchaseClosingCosts',
      'sellingCosts',
      'agentCommission',
    ],
  },
  {
    id: 'risk',
    title: 'Risk / stress testing',
    intro:
      'Stress presets rerun the same deal calculation after changing sale price, rehab, or holding time. A preset is an example scenario, not a forecast or an industry standard.',
    termIds: ['holdingPeriod', 'breakEvenSalePrice', 'arv'],
  },
  {
    id: 'grade',
    title: 'Deal Grade & Readiness',
    intro:
      'Modeled Deal Grade summarizes the saved model. It is not a recommendation to purchase. Readiness counts whether key assumptions have been provided. An entered zero counts as provided.',
    termIds: ['arv', 'cashOnCashReturn'],
  },
  {
    id: 'using',
    title: 'Using DealSkout',
    intro:
      'A full deal uses Overview, Purchase, Rehab, Financing, Market, Analysis, Risk, and Review. Tools such as Comp Finder and Deal Analyzer can be used before you save a deal. AI Deal Review explains saved evidence and does not change the deal, comps, or ARV.',
    termIds: ['compBasedIndication', 'mao'],
  },
];
